export default __webpack_public_path__ + "static/media/1.f80b0ac7.jpg";